import { render, staticRenderFns } from "./JgBespokeBetmgm.vue?vue&type=template&id=8b6dc7d6&scoped=true&"
import script from "./JgBespokeBetmgm.vue?vue&type=script&lang=ts&"
export * from "./JgBespokeBetmgm.vue?vue&type=script&lang=ts&"
import style0 from "./JgBespokeBetmgm.vue?vue&type=style&index=0&id=8b6dc7d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6dc7d6",
  null
  
)

export default component.exports